import React from 'react';

export default function LoadingSquaresAnimation() {
	return (
		<>
			<LoadingSkeleton />
			<LoadingSkeleton />
			<LoadingSkeleton />
			<LoadingSkeleton />
			<LoadingSkeleton />
			<LoadingSkeleton />
			<LoadingSkeleton />
			<LoadingSkeleton />
		</>
	);
}

export function LoadingSkeleton() {
	return (
		<div className="flex animate-pulse items-center mb-10 justify-start flex-col w-[90%] aspect-[16/12]">
			<div className="w-full aspect-[16/12] bg-gray-300 rounded-2xl "></div>
			<div className="w-1/2 mt-3">
				<div className="w-10/12 bg-gray-300 h-6 rounded-md "></div>
			</div>
		</div>
	);
}
